const money = (v) => new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(v || 0);
const BANNER_PATH = "/banner-contribuinte.jpg";
export const bannerUrl = () => `${window.location.origin}${BANNER_PATH}`;

export const PIX_INFO = `*Pague com PIX*
Chave: pixadsaparelheiros@adsabrasil.org.br

*Adsa Brasil Parelheiros*
Cód. Banco: 529 (Pinbank)
Agência: 0401
Conta: 293605
CNPJ: 62.971.759/0023-84`;

export const buildInviteText = (name = "") => `Olá${name ? `, ${name}` : ""}! A paz do Senhor!

*Seja um Contribuinte* da ADSA BRASIL - Campo de Parelheiros. Sua fidelidade sustenta a obra de Deus e abençoa muitas vidas.

${PIX_INFO}

"Cada um contribua segundo propôs no seu coração; não com tristeza, ou por necessidade; porque Deus ama ao que dá com alegria." (2 Coríntios 9:7)`;

export const buildReceiptText = (entry) => {
  const total = entry.pix + entry.cartao + entry.dinheiro;
  const date = new Date(`${entry.date}T12:00:00`).toLocaleDateString("pt-BR");
  const methods = [["Pix", entry.pix], ["Cartão", entry.cartao], ["Dinheiro", entry.dinheiro]].filter(([, v]) => v > 0).map(([l, v]) => `${l}: ${money(v)}`).join(" | ");
  return `Olá, ${entry.tither_name || entry.person_name}! A paz do Senhor!

*RECIBO DE DÍZIMO Nº ${entry.id.slice(-6).toUpperCase()}*
ADSA BRASIL - Campo de Parelheiros · ${entry.church}

Recebemos de *${entry.tither_name || entry.person_name}* a quantia de *${money(total)}* referente a dízimo, entregue em ${date}.
${methods}

Deus abençoe sua fidelidade! "Trazei todos os dízimos à casa do tesouro" (Malaquias 3:10)

${PIX_INFO}`;
};

const waNumber = (phone) => { const d = (phone || "").replace(/\D/g, ""); return d && d.length <= 11 ? `55${d}` : d; };

export const sendWhatsApp = async ({ phone, text, withBanner = true }) => {
  const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  if (withBanner && isMobile && navigator.canShare) {
    try {
      const blob = await (await fetch(BANNER_PATH)).blob();
      const file = new File([blob], "seja-um-contribuinte.jpg", { type: "image/jpeg" });
      if (navigator.canShare({ files: [file] })) { await navigator.share({ files: [file], text }); return "shared"; }
    } catch (err) { if (err?.name === "AbortError") return "cancelled"; }
  }
  const body = withBanner ? `${text}\n\nBanner: ${bannerUrl()}` : text;
  const number = waNumber(phone);
  window.open(`https://wa.me/${number}?text=${encodeURIComponent(body)}`, "_blank", "noopener");
  return "link";
};

export const buildBirthdayText = (name) => `Feliz aniversário, ${name}!

A ADSA BRASIL - Campo de Parelheiros celebra a sua vida! Que o Senhor te abençoe e te guarde, faça resplandecer o Seu rosto sobre ti e te conceda paz. (Números 6:24-26)

Receba o nosso carinho e as nossas orações neste dia especial!`;

export const buildReminderText = (name) => `Olá, ${name}! A paz do Senhor!

Passando para lembrar com carinho da sua fidelidade nos dízimos deste mês. Sua contribuição sustenta a obra de Deus na ADSA BRASIL - Campo de Parelheiros.

${PIX_INFO}

Deus abençoe sua vida! "Trazei todos os dízimos à casa do tesouro" (Malaquias 3:10)`;

export const buildStatementText = (st) => `Olá, ${st.name}! A paz do Senhor!

*COMPROVANTE ANUAL DE DÍZIMOS ${st.year}*
ADSA BRASIL - Campo de Parelheiros · ${st.church}

Total entregue em ${st.year}: *${money(st.total)}* (${st.count} dízimo${st.count === 1 ? "" : "s"}).

Obrigado pela sua fidelidade! Deus abençoe sua vida.`;

export const buildWelcomeText = (name, church) => `Olá, ${name}! A paz do Senhor!

Seja muito bem-vindo(a) à família ADSA BRASIL - Campo de Parelheiros${church ? ` · ${church}` : ""}! É uma alegria ter você conosco.

Conte com a nossa igreja para caminhar com você na fé, em oração e em comunhão. Estamos à disposição!

"Portanto, recebei-vos uns aos outros, como também Cristo nos recebeu para glória de Deus." (Romanos 15:7)`;
